import { Pie } from 'vue-chartjs';

export default {
  extends: Pie,
  props: {
    aggs: {
      type: Object,
      required: true
    }
  },
  mounted() {
    if (!this.aggs) {
      return;
    }

    const customers = Object.keys(this.aggs);
    const data = Object.values(this.aggs);

    const colors = this.generateColors(customers);

    this.renderChart(
      {
        datasets: [
          {
            data,
            backgroundColor: colors,
            borderWidth: 0
          }
        ],
        labels: customers
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        resizeDelay: 0,
        layout: {
          padding: { top: 20, bottom: 60, left: 20, right: 20 }
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            boxWidth: 12,
            padding: 15,
            usePointStyle: false
          }
        },
        elements: {
          arc: {
            borderWidth: 0
          }
        },
        devicePixelRatio: 1
      }
    );
  },
  methods: {
    generateColors(customers) {
      const colors = [];

      const defaultColors = ['#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#2ECC71', '#3498DB', '#E74C3C', '#F39C12', '#9B59B6'];

      let colorIndex = 0;

      customers.forEach(customer => {
        if (customer.toLowerCase() === 'unknown') {
          colors.push('#E74C3C');
        } else {
          if (colorIndex < defaultColors.length) {
            colors.push(defaultColors[colorIndex]);
          } else {
            colors.push(`hsl(${(colorIndex * 360) / customers.length}, 70%, 50%)`);
          }
          colorIndex++;
        }
      });

      return colors;
    }
  }
};
